<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      <el-breadcrumb-item>设备批量导入</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.mac" @keyup.enter.native="clicksearch" placeholder="请输入MAC地址" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.cardnumber" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择" class="select" style="width: 200px;">
              <el-option label="请选择设备类型" value=""></el-option>
              <el-option
                v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.saletype" placeholder="请选择" class="select" style="width: 200px;">
              <el-option
                v-for="item in saleTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
         <el-form-item label="">
            <el-select v-model="keywords.importstatus" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择导入状态" value="-1"></el-option>
              <el-option label="待处理" value="0"></el-option>
              <el-option label="已处理" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
             <el-select v-model="keywords.importresult" placeholder="请选择" class="select"  style="width: 200px;">
               <el-option label="请选择导入结果" value="-1"></el-option>
               <el-option label="待处理" value="0"></el-option>
               <el-option label="导入成功" value="1"></el-option>
               <el-option label="导入失败" value="2"></el-option>
             </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="创建时间(开始)" class="mr15"></el-date-picker>
            <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="创建时间(结束)" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="danger" @click="ProcessDevicePlLiang" v-if="SubRule_Device_AddPlLiangProcess">批量审核</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Jigouname" label="归属机构" min-width="8%"></el-table-column>
          <el-table-column prop="Batchno" label="批次号" min-width="10%"></el-table-column>
          <el-table-column prop="Mac" label="MAC地址" min-width="10%"></el-table-column>
          <el-table-column prop="Cardnumber" label="保修卡号" min-width="10%"></el-table-column>
          <el-table-column prop="BomsnName" label="设备类型" min-width="8%"></el-table-column>
          <el-table-column prop="SaletypeName" label="销售类型" min-width="8%"></el-table-column>
          <el-table-column prop="ImportstatusName" label="导入状态" min-width="8%"></el-table-column>
          <el-table-column prop="ImportresultName" label="导入结果" min-width="8%"></el-table-column>
          <el-table-column prop="Note" label="备注" min-width="14%"></el-table-column>
          <el-table-column prop="UseridimportName" label="导入人" min-width="8%"></el-table-column>
          <el-table-column prop="UseridoperationName" label="操作人" min-width="8%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 批量导入 start -->
      <el-tab-pane label="批量导入">
        <el-form :model="addDevice" ref="addDeviceRef" label-width="75px">
          <el-form-item label="归属机构" class="addAdminForm">
            <Rsljigou :propsjigouid="addDevice.jigouid" :propsjigouname="addDevice.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select v-model="addDevice.bomsn" placeholder="请选择" class="select" style="width: 300px;">
              <el-option label="请选择设备类型" value=""></el-option>
              <el-option
                v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售类型">
            <el-select v-model="addDevice.saletype" placeholder="请选择" class="select" style="width: 300px;">
              <el-option
                v-for="item in saleTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批次号" class="addAdminForm">
            <el-input v-model="addDevice.batchno" placeholder="请输入批次号"></el-input>
          </el-form-item>
          <el-form-item label="MAC" class="addAdminForm">
            <el-input type="textarea" :rows="10" v-model="addDevice.maclist" placeholder="请复制多行MAC地址进来."></el-input>
          </el-form-item>
          <el-form-item label="保修卡号" class="addAdminForm" v-if=" addDevice.bomsn == '103-0000-0004'">
            <el-input type="textarea" :rows="10" v-model="addDevice.cardnumberlist" placeholder="请复制多行保修卡号进来.只有5.0才需要保修卡号."></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 批量导入 end -->
    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyDeviceBatchImport',
  data () {
    return {
      activeName: 'first',
      bomSnList: [],
      saleTypeList: [],
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        mac: '',
        cardnumber: '',
        jigouid: '-1',
        jigouname: '',
        bomsn: '',
        saletype: '0',
        importstatus: '-1',
        importresult: '-1',
        begintime: '',
        endtime: ''
      },
      // 添加设备
      addDevice: {
        jigouid: '348',
        jigouname: '云端仓库',
        bomsn: '103-0000-0001',
        saletype: '1',
        batchno: '',
        maclist: '',
        cardnumberlist: ''
      },
      SubRule_Device_AddPlLiangProcess: false
    }
  },
  mounted () {
    this.GetDevicePlLiangnum()
    this.GetDevicePlLianglist()

    var that = this
    Vue.prototype.FunListBomsn(function (response) {
      if (response.data.Code === 200) {
        that.bomSnList = response.data.List
        that.saleTypeList = response.data.ListSaleType
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Device_AddPlLiangProcess', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Device_AddPlLiangProcess = true
      }
    })
  },
  methods: {
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
      this.addDevice.jigouid = vid
      this.addDevice.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetDevicePlLianglist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetDevicePlLiangnum()
      this.GetDevicePlLianglist()
    },
    clickadd () {
      this.AddDevicePlLiang()
    },
    GetDevicePlLianglist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        importstatus: that.keywords.importstatus,
        importresult: that.keywords.importresult,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDevicePlLianglist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetDevicePlLiangnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        importstatus: that.keywords.importstatus,
        importresult: that.keywords.importresult,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDevicePlLiangnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddDevicePlLiang: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.addDevice.jigouid,
        bomsn: that.addDevice.bomsn,
        saletype: that.addDevice.saletype,
        batchno: that.addDevice.batchno,
        maclist: that.addDevice.maclist,
        cardnumberlist: that.addDevice.cardnumberlist
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddDevicePlLiang, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addDevice.jigouid = '348'
            that.addDevice.jigouname = '云端仓库'
            that.addDevice.bomsn = '103-0000-0001'
            that.addDevice.saletype = '1'
            that.addDevice.batchno = ''
            that.addDevice.maclist = ''
            that.addDevice.cardnumberlist = ''

            that.GetDevicePlLiangnum()
            that.GetDevicePlLianglist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    ProcessDevicePlLiang: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ProcessDevicePlLiang, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetDevicePlLiangnum()
            that.GetDevicePlLianglist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
